"use client";

import { c as _c } from "react/compiler-runtime";
import { filterTypes as by } from "@repo/design-system/types/filter";
import { useLanguage } from "~/translations/loader/use-language";
import { MultiSelect } from "../filterbar/filters/multi-select";
import { SearchbarHungary } from "../filterbar/searchbar-eon-hungary";
export function NewsletterFilterbarEonHungary() {
  const $ = _c(14);
  const t = useLanguage();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="md:col-span-2"><SearchbarHungary /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [by.JOB_FIELD];
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t.filterbar_filter4_placeholder) {
    t2 = <MultiSelect filterBy={t1} id="newsletter_jobfield" label={t.filterbar_filter4_placeholder} />;
    $[2] = t.filterbar_filter4_placeholder;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [by.ENTRY_LEVEL_MULTI];
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t.filterbar_filter2_placeholder) {
    t4 = <MultiSelect filterBy={t3} id="newsletter_entrylevel" label={t.filterbar_filter2_placeholder} />;
    $[5] = t.filterbar_filter2_placeholder;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = [by.LOCATION_CITY];
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t.filterbar_filter1_placeholder) {
    t6 = <MultiSelect filterBy={t5} id="newsletter_location" label={t.filterbar_filter1_placeholder} />;
    $[8] = t.filterbar_filter1_placeholder;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t2 || $[11] !== t4 || $[12] !== t6) {
    t7 = <section className="grid w-full grid-flow-row gap-y-2 pb-4 md:grid-cols-2 md:gap-4" id="newsletter_filterbar">{t0}{t2}{t4}{t6}</section>;
    $[10] = t2;
    $[11] = t4;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}